import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { List, Card, Button, message, Modal, Tooltip } from "antd";
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import "./styles.module.scss";
import AppHelper from "libs/AppHelper";
import { API_HOST, GOOGLE_MAP_KEY } from "../../configs/env";
import whttp from "../../libs/whttp";
import GoogleMapReact from "google-map-react";
import googleMapIcon from "assets/img/icon/google_map.svg";
import BrandList from "blocks/brands/brand-list";
import classnames from "classnames";
import { __ } from "@wordpress/i18n";
import BraftEditor from "braft-editor";

import styles from "./vip-gift.module.scss";

const PLUGIN_ASSETS_URL = _.get(window, "VC_CONFIG.PLUGIN_ASSETS_URL");
const INDEX_URL = _.get(window, "VC_CONFIG.INDEX_URL");
const Locale = _.get(window, "VC_CONFIG.Locale");
const stringToBr = (text) => {
  return _.map(_.split(text, "\n"), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};
const default_image = PLUGIN_ASSETS_URL + "img/banner/store/banner-info.png";

let swiper129 = null;
let swiper130 = null;

function isMobileDevice() {
  var mobileDevices = ["Android", "iPhone", "iPad"];
  var isMobileDevice = false;
  for (var i = 0; i < mobileDevices.length; i++) {
    if (navigator.userAgent.match(mobileDevices[i])) {
      isMobileDevice = true;
    }
  }
  return isMobileDevice;
}

// 前端頁面
// 店基本資訊、地圖、美食外送、商店購物
// 美食購物分類、品牌購物分類
// 購物中心樓層介紹 （建議的）
export default class BrandInfo extends Component {
  state = {
    tabType: "info",
    brandInfo: undefined,
    categoryList: [],
    category129: [],
    category130: [],
  };

  componentDidMount() {
    this.setState({
      tabType: AppHelper.getHashValue("tab") || "info",
    });
    this.loadData();
    this.fetchCategoryList();
  }

  loadData = () => {
    const urlQuery = AppHelper.getURLQuery();
    const brand = _.get(urlQuery, "brand");
    if (!brand) return this.props.history.replace("/brands");
    this.setState({ isFetchData: true });
    whttp.sharedGet(
      API_HOST + `/api/v1/brands/${brand}`,
      null,
      (state, res) => {
        this.setState({ isFetchData: false });
        const { code = 100, reason = "發生錯誤", data = {} } = res;
        if (state === false || code !== 200) {
          message.warning(reason);
          this.props.history.replace("/brands");
          return;
        }
        this.setState({ brandInfo: data });
        this.loadHTMLdesc(data);
      }
    );
  };

  loadHTMLdesc = (info = {}) => {
    if (Locale == "en_US" && info.en_desc) {
      document.getElementById("output-desc-content").innerHTML = info.en_desc;
    } else {
      document.getElementById("output-desc-content").innerHTML = info.desc;
    }
  };

  reloadSwiper129 = _.debounce(() => {
    if (this.state.category129.length > 0) {
      const Swiper = window.Swiper;
      if (!Swiper || swiper129) return;
      console.log("1");
      swiper129 = new Swiper(`.swiper-container-129`, {
        initialSlide: 0,
        spaceBetween: 10,
        loop: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: `.swiper-container-129 .swiper-pagination`,
          clickable: true,
        },
      });
    }
  }, 500);

  reloadSwiper130 = _.debounce(() => {
    if (this.state.category130.length > 0) {
      const Swiper = window.Swiper;
      if (!Swiper || swiper130) return;
      console.log("2");
      swiper130 = new Swiper(`.swiper-container-130`, {
        initialSlide: 0,
        spaceBetween: 10,
        loop: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: `.swiper-container-130 .swiper-pagination`,
          clickable: true,
        },
      });
    }
  }, 500);

  fetchCategoryList = () => {
    const brandInfo = _.get(this, "state.brandInfo", {});
    whttp.get(
      `${API_HOST}/api/v1/news`,
      { page: 1, page_size: "all" },
      (state, res) => {
        const { code = 100, reason = "發生錯誤", data = {} } = res;
        if (state === false || code !== 200) return;
        this.setState({ categoryList: data.rows }, () => {
          const { categoryList } = this.state;
          const category129 = categoryList.filter((c) => c.category_id === 129); //品牌活動快訊
          const category130 = categoryList.filter((c) => c.category_id === 130); //產品介紹
          this.reloadSwiper129();
          this.reloadSwiper130();
          this.setState({ category129, category130 });
        });
      }
    );
  };

  render() {
    let { category129, category130 } = this.state;

    const brandInfo = _.get(this, "state.brandInfo", {});
    const news = _.get(this, "state.brandInfo.news", []);
    const Local = _.get(window, "VC_CONFIG.Locale");
    console.log("bbbbbb", category129, category130);
    category129 = category129.filter((c) => c.brands.includes(brandInfo.id));
    category130 = category130.filter((c) => c.brands.includes(brandInfo.id));
    const isMobile = isMobileDevice();

    console.log("sssss", category129, category130);

    return (
      <Fragment>
        <div class="bg-light">
          <div class="container">
            <div class="breadcrumb-wrap py-4 m-0">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}${
                        Local == "en_US" ? "/en" : ""
                      }`}
                    >
                      {__("首頁", "cec-plugin-stores")}
                    </a>
                  </li>
                  <li class="breadcrumb-item">
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}/shopping-mall${
                        Local == "en_US" ? "-en" : ""
                      }`}
                    >
                      {__("購物中心", "cec-plugin-stores")}
                    </a>
                  </li>
                  <li
                    class="breadcrumb-item active"
                    aria-current="page"
                    id="name"
                  >
                    {Locale == "en_US" &&
                      brandInfo.en_name &&
                      brandInfo.en_name}
                    {(Locale == "zh_TW" ||
                      (Locale == "en_US" && !brandInfo.en_name)) &&
                      brandInfo.name}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        <div class="banner">
          <div class="banner-image brand-image" style={{ height: isMobile ? 200 : 400 }}>
            <img src={brandInfo.image_url || default_image} alt="" />
            <h3 class="title">{""}</h3>
          </div>
          <div
            class="store-brand-logo-wrapper"
            style={{ width: 1200, margin: "0 auto" }}
          >
            <div
              class="store-brand-logo-link"
              role="button"
              style={{
                width: isMobile ? 144 : 255,
                height: isMobile ? 144 : 255,
                marginLeft: isMobile ? 15 : 0,
                left: "5%",
                borderRadius: 8,
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 1,
              }}
            >
              <img src={brandInfo.logo_url} alt="" />
            </div>
          </div>
        </div>
        <main class="bg-light">
          <div class="container">
            <div class="brand-info mb-4" style={{ marginTop: 0 }}>
              <div class="row align-items-end">
                <div class="col-12">
                  <div class="brand-info-text mt-5">
                    <h4 class="h3 text-navy">
                      {Locale == "zh_TW" ||
                        (Locale == "en_US" &&
                          !brandInfo.en_name &&
                          brandInfo.name)}
                      {Locale == "en_US" &&
                        brandInfo.en_name &&
                        brandInfo.en_name}
                    </h4>
                    <p
                      id="output-desc-content"
                      class="p text-navy text-justify mt-3 mt-lg-5 mb-0"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              {category129.length > 0 && (
                <div class="col-12 col-md-6">
                  <h4 class="heading-title text-center">活動快訊</h4>
                  <hr class="border-top border-gray mt-0 mb-4" />
                  <div
                    class="swiper-container-129"
                    style={{ overflow: "hidden" }}
                  >
                    <div class="swiper-wrapper">
                      {category129.map((item, idx) => {
                        return (
                          <div key={idx} class="swiper-slide">
                            <a
                              class="card text-decoration-none border-0 shadow-0 p-0"
                              role="button"
                              href={AppHelper.getNewsLink(item)}
                              onClick={(e) => {
                                if (AppHelper.getNewsLink(item) === "#") {
                                  e.preventDefault();
                                }
                              }}
                            >
                              <div
                                class="img-2-1"
                                style={{
                                  backgroundImage: `url(${_.get(
                                    item,
                                    "images.0.url"
                                  )})`,
                                }}
                              />
                              <div class="card-body p-3">
                                <h5 class="text-navy limit-line-1 mb-2 h6">
                                  {item.name}
                                </h5>
                              </div>
                            </a>
                          </div>
                        );
                      })}
                    </div>
                    <div class="swiper-pagination" />
                  </div>
                </div>
              )}
              {category130.length > 0 && (
                <div class="col-12 col-md-6">
                  <h4 class="heading-title text-center">產品介紹</h4>
                  <hr class="border-top border-gray mt-0 mb-4" />
                  <div
                    class="swiper-container-130"
                    style={{ overflow: "hidden" }}
                  >
                    <div class="swiper-wrapper">
                      {category130.map((item, idx) => {
                        return (
                          <div key={idx} class="swiper-slide">
                            <a
                              class="card text-decoration-none border-0 shadow-0 p-0"
                              role="button"
                              href={AppHelper.getNewsLink(item)}
                              onClick={(e) => {
                                if (AppHelper.getNewsLink(item) === "#") {
                                  e.preventDefault();
                                }
                              }}
                            >
                              <div
                                class="img-2-1"
                                style={{
                                  backgroundImage: `url(${_.get(
                                    item,
                                    "images.0.url"
                                  )})`,
                                }}
                              />
                              <div class="card-body p-3">
                                <h5 class="text-navy limit-line-1 mb-2 h6">
                                  {item.name}
                                </h5>
                              </div>
                            </a>
                          </div>
                        );
                      })}
                    </div>
                    <div class="swiper-pagination" />
                  </div>
                </div>
              )}
            </div>
            <div class="container">
              {_.map(
                _.groupBy(brandInfo.deliveries, (vendor) => vendor.vendor_id),
                (vendors, idx) => {
                  let vendorHasIcon = _.find(
                    vendors,
                    (vendor) => vendor.image !== null
                  );
                  return (
                    <a
                      role="button"
                      key={idx}
                      class="my-lg-5 my-3"
                      onClick={(e) => {
                        Modal.info({
                          title: "請選擇品牌所在分店",
                          okText: "取消",
                          content: (
                            <div class="row no-gutters mx-n2" id="item">
                              {vendors.map((vendor, idx) => (
                                <div key={idx} class="col-auto px-2">
                                  <a href={vendor.url}>
                                    <span
                                      class="p btn btn-outline-primary px-3 rounded-pill my-2 service-badge"
                                      role="button"
                                    >
                                      {vendor.store_name}
                                    </span>
                                  </a>
                                </div>
                              ))}
                            </div>
                          ),
                        });
                      }}
                    >
                      <img
                        class="img-cover"
                        src={vendorHasIcon.image}
                        alt={vendorHasIcon.vendor_name}
                      />
                    </a>
                  );
                }
              )}
            </div>
            {/* {_.isArray(news) && news.length > 0 && (
              <Fragment>
                <h4 class="heading-title justify-content-center">
                  {__("品牌活動", "cec-plugin-stores")}
                </h4>
                <hr class="border-top border-gray mt-0 mb-4" />
                <div class="row no-gutters mx-n3">
                  {news.length <= 4 && (
                    <Fragment>
                      {_.map(news, (newsInfo, idx) => {
                        let col =
                          idx === 0 || newsInfo.length <= 4 ? null : "mb-4";
                        return (
                          <div className="col-md-6 px-3 mb-4">
                            <a
                              class="card h-100 text-decoration-none border-0 shadow-0 p-0"
                              role="button"
                              href={AppHelper.getNewsLink(newsInfo)}
                            >
                              <div
                                class="img-2-1"
                                style={{
                                  backgroundImage: `url(${_.get(
                                    newsInfo,
                                    "images.0"
                                  )})`,
                                }}
                              />
                              <div class="card-body h-100 p-3">
                                <h5 class="text-navy limit-line-1 mb-2 h6">
                                  {newsInfo.name}
                                </h5>
                                <p class="note text-dark mb-0">
                                  {newsInfo.desc}
                                </p>
                              </div>
                            </a>
                          </div>
                        );
                      })}
                    </Fragment>
                  )}
                  {news.length > 4 && (
                    <Fragment>
                      <div className="col-md-6 px-3 mb-4">
                        <a
                          class="card h-100 text-decoration-none border-0 shadow-0 p-0"
                          role="button"
                          href={AppHelper.getNewsLink(_.get(news, "0"))}
                        >
                          <div
                            class="img-2-1"
                            style={{
                              backgroundImage: `url(${_.get(
                                news,
                                "0.images.0"
                              )})`,
                            }}
                          />
                        </a>
                      </div>
                      <div class="col-lg-6 px-3">
                        <div class="row no-gutters mx-n3">
                          {_.map(
                            news.filter((_, idx) => idx !== 0),
                            (newsInfo, idx) => {
                              let col =
                                idx === 0 || newsInfo.length <= 4
                                  ? null
                                  : "mb-4";
                              return (
                                <div
                                  className={classnames(col, "col-lg-6 px-3")}
                                >
                                  <a
                                    class="card h-100 text-decoration-none border-0 shadow-0 p-0"
                                    role="button"
                                    href={AppHelper.getNewsLink(newsInfo)}
                                  >
                                    <div
                                      class="img-2-1"
                                      style={{
                                        backgroundImage: `url(${_.get(
                                          newsInfo,
                                          "images.0"
                                        )})`,
                                      }}
                                    />
                                    <div class="card-body h-100 p-3">
                                      <h5 class="text-navy limit-line-1 mb-2 h6">
                                        {newsInfo.name}
                                      </h5>
                                      <p class="note text-dark mb-0">
                                        {newsInfo.desc}
                                      </p>
                                    </div>
                                  </a>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </Fragment>
                  )}
                </div>
              </Fragment>
            )} */}
            <h4 class="heading-title justify-content-start">
              {__("所在分店", "cec-plugin-stores")}{" "}
            </h4>
            <hr class="border-top border-gray mt-0 mb-4" />
            <div class="section pt-md-5">
              <div class="row">
                {_.map(_.get(brandInfo, "stores", []), (storeInfo, idx) => (
                  <Fragment>
                    <div class="col-md-6 col-lg-4">
                      <div class="card card-storeInfo brand-theme shadow-0 card-border-width-1 type-1">
                        <a
                          className="card-body"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.persist();
                            if (
                              e.target.className.includes("vip") ||
                              e.target.className.includes("gift") ||
                              e.target.id.includes("gMap-link")
                            )
                              return;
                            window.location.href = `${INDEX_URL}/store-info${
                              Locale == "en_US" ? "-en" : ""
                            }/?store=${storeInfo.name}#tab=info`;
                          }}
                        >
                          <div class="ml-3" style={{ display: "flex" }}>
                            <h5 class="h4 pl-4 mb-4">
                              {Locale == "en_US" &&
                                storeInfo.en_name &&
                                storeInfo.en_name}
                              {(Locale == "zh_TW" ||
                                (Locale == "en_US" && !storeInfo.en_name)) &&
                                storeInfo.name}
                            </h5>
                            {storeInfo.BrandVoucher.is_vip === 1 && (
                              <Tooltip title="享VIP優惠">
                                <div
                                  className={styles.vip}
                                  style={{ cursor: "default" }}
                                >
                                  <span className={styles.vip1}>VIP</span>
                                </div>
                              </Tooltip>
                            )}
                            {storeInfo.BrandVoucher.is_gift === 1 && (
                              <Tooltip title="可使用禮券">
                                <div
                                  className={styles.gift}
                                  style={{ cursor: "default" }}
                                >
                                  <span className={styles.gift1}>禮券</span>
                                </div>
                              </Tooltip>
                            )}
                            {storeInfo.BrandVoucher.is_gift === 1 && (
                              <Tooltip title="可使用禮物卡">
                                <div
                                  style={{ width: "55px", cursor: "default" }}
                                  className={styles.gift}
                                >
                                  <span
                                    className={styles.gift1}
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "45px",
                                    }}
                                  >
                                    禮物卡
                                  </span>
                                </div>
                              </Tooltip>
                            )}
                          </div>
                          <ul class="traffic-info-list">
                            <li>
                              <i class="icon-store_map" />
                              <span>
                                {Locale == "en_US" &&
                                  storeInfo.en_street &&
                                  storeInfo.en_street}
                                {(Locale == "zh_TW" ||
                                  (Locale == "en_US" &&
                                    !storeInfo.en_street)) &&
                                  storeInfo.address &&
                                  storeInfo.address}
                                <a
                                  class="gMap-link"
                                  role="button"
                                  href={`https://www.google.com.tw/maps/place/${
                                    storeInfo.address
                                  }`}
                                  target="_blank"
                                >
                                  <img
                                    id="gMap-link"
                                    class="ml-3"
                                    src={`${PLUGIN_ASSETS_URL}img/icon/google_map.svg`}
                                    alt=""
                                  />
                                </a>
                              </span>
                            </li>
                            {/* <li>
                              <i class="icon-store_phone" />
                              <span>{storeInfo.contact_tel}</span>
                            </li> */}
                            {/* <li>
                              <i class="icon-store_clock" />
                              <span>
                                {Locale == "en_US" &&
                                  storeInfo.en_business_hours &&
                                  _.get(
                                    storeInfo,
                                    "en_business_hours",
                                    ""
                                  ).substring(0, 40)}
                                {(Locale == "zh_TW" ||
                                  (Locale == "en_US" &&
                                    !storeInfo.en_business_hours)) &&
                                  storeInfo.business_hours &&
                                  _.get(
                                    storeInfo,
                                    "business_hours",
                                    ""
                                  ).substring(0, 40)}
                              </span>
                            </li> */}
                            {/* <li> <i className="icon-store_car"></i><span>停車資訊 / 汽車{item.parking_spaces_car}位 / 機車{item.parking_moto}位 / 親子{item.parking_spaces_parent}位 / 殘障{item.parking_spaces_handicapped}位</span></li> */}
                          </ul>
                        </a>
                      </div>
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </main>
      </Fragment>
    );
  }
}

// 編輯器
export class BrandInfoEditor extends Component {
  render() {
    return (
      <div className="vu-blocks-editor">
        <div class="components-placeholder__label">
          <span class="block-editor-block-icon">
            <div class="dashicons dashicons-layout" />
          </span>
          品牌資訊
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/brands/brand-info.js